import produce from 'immer';
import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';

import { ICommonStore } from './type';

const useCommonStore = create<ICommonStore>()(
	devtools(
		immer((set) => ({
			modal_position: { top: null, left: null, bottom: null, right: null },
			setModalPosition: (position) => {
				set((state) => {
					const obj = state.modal_position;

					for (const key in position) {
						if (key === 'top') {
							obj.top = position.top;
						}
						if (key === 'left') {
							obj.left = position.left;
						}
						if (key === 'bottom') {
							obj.bottom = position.bottom;
						}
						if (key === 'right') {
							obj.right = position.right;
						}
					}

					state.modal_position = obj;
				});
			},
			// toast
			toast_data: {
				mount: false,
				text: '',
				permanant: false,
				is_error: false,
			},
			setToastData: (field, value) =>
				set((state) => {
					state.toast_data[field] = value;
				}),
			// platform
			platform: {
				code: null,
				name: null,
			},
			setPlatform: (value) =>
				set((state) => {
					state.platform = value;
				}),

			// trend
			trend: JSON.parse(localStorage.getItem('trend') ?? '[]'),
			setTrend: (value) => {
				set((state) => {
					state.trend = value;
				});
			},
			checked_trend: [],
			setCheckedTrend: (value) => {
				set((state) => {
					state.checked_trend = value;
				});
			},

			// nth ordinal
			ordinal: {
				ordinal_number: 1,
				mission_number: 1,
			},
			setOrdinal: (value) =>
				set((state) => {
					state.ordinal.ordinal_number = value.ordinal_number;
					state.ordinal.mission_number = value.mission_number;
				}),

			// match - filter
			filter: {
				ig_filter: {
					content_type: '',
					account_type: '',
					categories: '',
					followers: '',
					estimate_gender: '',
					estimate_age: '',
					campaign_experience: '',
				},
				yt_filter: {
					content_type: '',
					categories: '',
					followers: '',
					estimate_gender: '',
					estimate_age: '',
				},
				nb_filter: {
					categories: '',
					followers: '',
				},
				tt_filter: {
					categories: '',
					followers: '',
					estimate_gender: '',
					estimate_age: '',
				},
				common_filter: {
					order_by: 'random',
					order: 'desc',
				},
			},
			setFilter: (code, value) =>
				set((state) => {
					state.filter[`${code}_filter`] = value;
				}),
			setCommonFilter: (key, value) =>
				set((state) => {
					state.filter.common_filter[`${key}`] = value;
				}),
			// table
			header: [],
			setHeader: (list) =>
				set((state) => {
					state.header = list;
				}),
			column_width: [],
			setColumnWidth: (list) =>
				set((state) => {
					state.column_width = list;
				}),
			setIndexColumnWidth: (idx, width) =>
				set((state) => {
					state.column_width[idx] = width;
				}),
			page: 1,
			setPage: (value) =>
				set((state) => {
					state.page = value;
				}),
			preview_idx: null,
			setPreviewIdx: (value) =>
				set((state) => {
					state.preview_idx = value;
				}),
			is_scroll: false,
			setIsScroll: (value) =>
				set((state) => {
					state.is_scroll = value;
				}),
			// search
			search_platform: {
				code: 'ig,yt',
				name: '전체',
			},
			setSearchPlatform: (value) =>
				set((state) => {
					state.search_platform = value;
				}),
			keyword: '',
			setKeyword: (value) =>
				set((state) => {
					state.keyword = value;
				}),
			influencerId: '',
			setInfluencerId: (value) =>
				set((state) => {
					state.influencerId = value;
				}),
			search_modal: false,
			setSearchModal: (value) =>
				set((state) => {
					state.search_modal = value;
				}),
			selected_recommend: {
				text: '',
				idx: null,
			},
			setSelectedRecommend: (value) =>
				set((state) => {
					state.selected_recommend = value;
				}),
			selected_influencer: {
				text: '',
				idx: null,
			},
			setSelectedInfluencer: (value) =>
				set((state) => {
					state.selected_influencer = value;
				}),
			bg_scroll_top: 0,
			setBgScrollTop: (value) =>
				set((state) => {
					state.bg_scroll_top = value;
				}),
			is_sticky: false,
			setIsSticky: (value) =>
				set((state) => {
					state.is_sticky = value;
				}),
			table_header_ref: null,
			setTableHeaderRef: (value) =>
				set(
					produce((state) => {
						state.table_header_ref = value;
					}),
				),
			search_filter: { name: '전체', code: 'total' },
			setSearchFilter: (value) =>
				set((state) => {
					state.search_filter = value;
				}),
			// report
			report_scroll_on: false,
			setReportScrollOn(value) {
				return set((state) => {
					state.report_scroll_on = value;
				});
			},
		})),
	),
);

export default useCommonStore;
